import axios from 'axios';
import EncryptUtility from '../../utility/js/encrypt-utility';

function applyTheme(vuetify, themeCode) {
  const isDark = themeCode === 'Dark';
  vuetify.theme.dark = isDark;
  EncryptUtility.localStorageEncrypt('theme', JSON.stringify(isDark));
  EncryptUtility.localStorageEncrypt('themeCode', JSON.stringify(themeCode));
}

function updateTheme(userId, themeCode) {
  return axios.post('ap/user_profile_update', {
    UserId: userId,
    ThemeCode: themeCode,
  });
}

export default {
  applyTheme,
  updateTheme,
};
